import React from 'react';
import { createInertiaApp } from '@inertiajs/react';
import { createRoot } from 'react-dom/client';
import AuthLayout from './components/layout/auth/AuthLayout';
import Layout from './components/layout/app/Layout';
import PublicLayout from './components/layout/public/PublicLayout';

createInertiaApp({
    title: title => title || 'Schotpoort Portal',
    resolve: name => {
        const pages = require.context('./Pages', true, /\.jsx$/);
        const page = pages(`./${name}.jsx`);
        if (!page.default.layout) {
            const isAuth = name.startsWith('Auth/') && name !== 'Auth/ConfirmPassword';
            const isError = name.startsWith('Error/');
            const isPublic = name.startsWith('TrackAndTrace/');

            if (isPublic) {
                page.default.layout = (page) => <PublicLayout>{page}</PublicLayout>;
            } else if (isError) {
                page.default.layout = (page) => {
                    const auth = page.props?.auth;
                    return auth ? <Layout>{page}</Layout> : <AuthLayout>{page}</AuthLayout>;
                };
            } else {
                page.default.layout = (page) => isAuth ? <AuthLayout>{page}</AuthLayout> : <Layout>{page}</Layout>;
            }
        }
        return page;
    },
    setup({ el, App, props }) {
        createRoot(el).render(<App {...props} />);
    },
});
